import { MessageCircle } from "lucide-react";

// Normalise a phone number for wa.me — digits only, no leading zeros
function toWaNumber(raw) {
    if (!raw) return "";
    const digits = raw.replace(/[^0-9]/g, "");
    return digits.replace(/^0+/, "");
}

export default function WhatsAppButton({ settings }) {
    const raw = settings?.whatsapp || settings?.mobile || settings?.phone || "";
    const number = toWaNumber(raw);
    if (!number) return null;

    const business = settings?.business_name || "Auto Euro Parts";
    const text = encodeURIComponent(
        `Hi ${business}, I'm looking for a part and would like to chat.`
    );
    const href = `https://wa.me/${number}?text=${text}`;

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
            data-testid="whatsapp-float-btn"
            className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-50 group inline-flex items-center gap-3 pl-4 pr-5 py-3.5 bg-[#25D366] hover:bg-[#1eb956] text-white shadow-[0_10px_30px_-5px_rgba(37,211,102,0.6)] rounded-full transition-all duration-300 hover:scale-105"
        >
            <span className="relative flex items-center justify-center w-6 h-6">
                <span className="absolute inset-0 rounded-full bg-white/40 animate-ping" />
                <MessageCircle className="w-5 h-5 relative fill-white stroke-[#25D366]" />
            </span>
            <span className="hidden sm:inline text-xs uppercase tracking-[0.25em] font-bold whitespace-nowrap">
                Chat on WhatsApp
            </span>
        </a>
    );
}
